import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx/state';
import { LIST_ID } from '®shared/container-structure';
import { HideModalReason, ModalControlsSaveable } from '®shared/modals';
import { RedirectionService } from '®shared/redirection';
import { UriService } from '®shared/url-utils';

import {
  DeleteListAction,
  DeleteListHideModalAction,
} from './delete-list.actions';
import { selectDeleteListState } from './delete-list.state';

@Component({
  selector: 'rl-delete-list-modal',
  templateUrl: './delete-list-modal.component.html',
})
export class DeleteListModalComponent implements OnDestroy, OnInit {
  @ViewChild('deleteListModal', { static: true })
  public deleteListModal: ModalDirective;

  private stateSubscription: Subscription;
  modalControl: ModalControlsSaveable;
  modalHiddenReason: HideModalReason;

  constructor(
    private cd: ChangeDetectorRef,
    @Inject(LIST_ID) public listId: string,
    private redirectionService: RedirectionService,
    private store: Store<State>,
    private uriService: UriService,
  ) {}

  ngOnInit() {
    this.stateSubscription = this.store
      .select(selectDeleteListState)
      .subscribe(state => {
        this.modalControl = state.modalControl;
        this.modalHiddenReason = state.modalHiddenReason;

        const { isShown } = state.modalControl;
        if (isShown && !this.deleteListModal.isShown) {
          this.deleteListModal.show();
        } else if (!isShown && this.deleteListModal.isShown) {
          this.deleteListModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  onConfirm() {
    if (this.modalControl.isSaving) {
      return;
    }

    this.store.dispatch(new DeleteListAction({ listId: this.listId }));
  }

  onCancel() {
    if (this.modalControl.isSaving) {
      return;
    }

    this.store.dispatch(
      new DeleteListHideModalAction({
        listId: this.listId,
        reason: HideModalReason.CANCELLED,
      }),
    );
  }

  onHidden() {
    if (this.modalHiddenReason === HideModalReason.COMPLETED) {
      const myListsUri = this.uriService.getTarlMyListsUrl();
      this.redirectionService.redirectToExternalUrl(myListsUri);
    } else {
      this.onCancel();
    }
  }
}
